var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Admin__PlannerRuns__Page", attrs: { dir: "rtl" } },
    [
      _c("h1", [_vm._v("ריצות לילה של התוכניות")]),
      _c(
        "b-table",
        {
          staticClass: "runs-table",
          attrs: {
            data: _vm.runs,
            loading: _vm.isLoading,
            paginated: "",
            "backend-pagination": "",
            "pagination-simple": "",
            total: _vm.total,
            "per-page": _vm.perPage,
            "current-page": _vm.page,
            bordered: true,
            hoverable: true,
            selected: _vm.selectedRun,
            "row-class": (row) => _vm.getRunRowClass(row),
          },
          on: { "page-change": _vm.onPageChange, click: _vm.selectRun },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function () {
                return [
                  _c("div", { staticClass: "has-text-centered" }, [
                    _vm._v("אין ריצות להצגה"),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table-column", {
            attrs: { centered: "", field: "id", label: "מזהה" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.id) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { centered: "", field: "startedAt", label: "התחלה" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(props.row.startedAt)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { centered: "", field: "finishedAt", label: "סיום" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.row.finishedAt
                            ? _vm.formatDate(props.row.finishedAt)
                            : "לא הסתיימה"
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: {
              centered: "",
              field: "totalCombos",
              label: "סה״כ תלמידים בקורסים",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.totalCombos) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { centered: "", field: "succeededCount", label: "הצליחו" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.succeededCount) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { centered: "", field: "failedCount", label: "נכשלו" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(" " + _vm._s(props.row.failedCount) + " ")]
                },
              },
            ]),
          }),
          _c("b-table-column", {
            attrs: { centered: "", field: "status", label: "סטטוס" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    !props.row.finishedAt
                      ? _c("b-tag", { attrs: { type: "is-warning" } }, [
                          _vm._v("לא הסתיימה"),
                        ])
                      : props.row.failedCount
                      ? _c("b-tag", { attrs: { type: "is-danger" } }, [
                          _vm._v("הסתיימה עם כשלים"),
                        ])
                      : _c("b-tag", { attrs: { type: "is-success" } }, [
                          _vm._v("הצליחה"),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.selectedRun
        ? _c(
            "div",
            { staticClass: "Admin__PlannerRuns__Page__Failures" },
            [
              _c("h2", [
                _vm._v(
                  "כשלים בריצה " +
                    _vm._s(_vm.selectedRun.id) +
                    " (" +
                    _vm._s(_vm.formatDate(_vm.selectedRun.startedAt)) +
                    ")"
                ),
              ]),
              _c(
                "b-table",
                {
                  attrs: {
                    data: _vm.failures,
                    loading: _vm.isLoadingFailures,
                    bordered: true,
                    striped: true,
                    detailed: "",
                    "detail-key": "id",
                    "show-detail-icon": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "detail",
                        fn: function (props) {
                          return [
                            _c("div", { staticClass: "error-message-full" }, [
                              _vm._v(_vm._s(props.row.errorMessage)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "empty",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "has-text-centered" }, [
                              _vm._v("אין כשלים בריצה זו"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2380735029
                  ),
                },
                [
                  _c("b-table-column", {
                    attrs: {
                      centered: "",
                      field: "userId",
                      label: "מזהה תלמיד",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.userId) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3079147969
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: {
                      centered: "",
                      field: "studentName",
                      label: "שם תלמיד",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.studentName) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2628341971
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: {
                      centered: "",
                      field: "userName",
                      label: "שם משתמש",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.userName) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      527379467
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: { centered: "", field: "courseName", label: "קורס" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(props.row.courseId) +
                                  " - " +
                                  _vm._s(props.row.courseName) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2770212659
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: {
                      centered: "",
                      field: "httpStatusCode",
                      label: "סטטוס HTTP",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(
                                " " + _vm._s(props.row.httpStatusCode) + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1563946428
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: {
                      centered: "",
                      field: "errorType",
                      label: "סוג שגיאה",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.errorType) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3668952093
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: { field: "errorMessage", label: "הודעת שגיאה" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticClass: "error-message-preview" },
                                [_vm._v(_vm._s(props.row.errorMessage))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3765984701
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: { centered: "", field: "failedAt", label: "זמן" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDate(props.row.failedAt)) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2880951709
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }